import { useMemo, useState } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CharacterCounter } from 'foundations-components/transitional/components/CharacterCounter';
import { Popover, PopoverHeader, PopoverCloseButton, PopoverBody } from 'foundations-components/transitional/components/Popover';
import Selectors from 'feedback-public-submission-ui/constants/Selectors';
import { getSurveyTypeFromPath } from 'feedback-public-submission-ui/utils/SurveyPathUtils';
import { getFollowUpQuestion } from 'feedback-public-submission-ui/utils/getFollowUpQuestion';
import SubmitButton from 'feedback-public-submission-ui/components/SubmitButton';
import { H4 } from 'foundations-components/transitional/components/H4';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FOLLOW_UP_NUM_ROWS = 5;
const MAX_FOLLOW_UP_CHARS = 1500;
const CURRENT_SURVEY_TYPE = getSurveyTypeFromPath();
const FollowUp = ({
  surveyType = CURRENT_SURVEY_TYPE,
  feedbackResponse,
  surveyConfig,
  handleClickSubmit,
  handleFollowUpChange,
  isTest
}) => {
  const [popoverOpen, setPopoverOpen] = useState(isTest);
  const followUpQuestion = useMemo(() => {
    if (surveyConfig) {
      return getFollowUpQuestion(surveyType, feedbackResponse.rating, surveyConfig);
    }
    return '';
  }, [surveyConfig, feedbackResponse, surveyType]);
  return /*#__PURE__*/_jsxs("div", {
    className: "follow-up",
    children: [/*#__PURE__*/_jsx("h5", {
      className: "question-text",
      "data-selenium-test": Selectors.FOLLOW_UP.TEXT,
      children: followUpQuestion
    }), /*#__PURE__*/_jsx(NavMarker, {
      name: "FOLLOW-UP_INPUT_LOADED",
      children: /*#__PURE__*/_jsx(CharacterCounter, {
        counter: "down",
        "data-selenium-test": Selectors.FOLLOW_UP.INPUT,
        max: MAX_FOLLOW_UP_CHARS,
        maxLength: MAX_FOLLOW_UP_CHARS,
        onChange: handleFollowUpChange
        // @ts-ignore it's there
        ,
        resize: false,
        rows: FOLLOW_UP_NUM_ROWS,
        value: feedbackResponse.followUp
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "button-wrapper",
      children: /*#__PURE__*/_jsx(Popover, {
        content: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(PopoverHeader, {
            children: [/*#__PURE__*/_jsx(H4, {
              marginBlockEnd: "0",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "feedbackPublicUi.submitTest.header"
              })
            }), /*#__PURE__*/_jsx(PopoverCloseButton, {
              popoverUse: "longform",
              onClick: () => setPopoverOpen(false)
            })]
          }), /*#__PURE__*/_jsx(PopoverBody, {
            children: /*#__PURE__*/_jsx(View, {
              marginBlockEnd: "300",
              as: "div",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "feedbackPublicUi.submitTest.body"
              })
            })
          })]
        })
        // @ts-ignore it's there
        ,
        disabled: !isTest,
        open: popoverOpen,
        placement: "bottom",
        use: "longform",
        width: 280,
        children: /*#__PURE__*/_jsx(NavMarker, {
          name: "SUBMIT_BUTTON_LOADED",
          children: /*#__PURE__*/_jsx(SubmitButton, {
            surveyConfig: surveyConfig,
            feedbackResponse: feedbackResponse,
            handleClickSubmit: handleClickSubmit
          })
        })
      })
    })]
  });
};
export default FollowUp;